import { render, staticRenderFns } from "./RechargeQuota.vue?vue&type=template&id=b795257c&scoped=true"
import script from "./RechargeQuota.vue?vue&type=script&lang=js"
export * from "./RechargeQuota.vue?vue&type=script&lang=js"
import style0 from "./RechargeQuota.vue?vue&type=style&index=0&id=b795257c&prod&scoped=true&lang=css"
import style1 from "./RechargeQuota.vue?vue&type=style&index=1&id=b795257c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b795257c",
  null
  
)

export default component.exports